<template>
    <div class="book">
        <div class="left-image" @click="toDetail(bookInfo.id, bookInfo.chapter_id)">
            <el-image :src="bookInfo.cover_url" lazy alt="">
                <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                </div>
            </el-image>
        </div>

        <div class="right-info">
            <div class="noveltitle" @click="toDetail(bookInfo.id, bookInfo.chapter_id)">{{ bookInfo.name }}</div>
            <div class="novel-des">{{ bookInfo.category_name }} | {{ bookInfo.word_count }}字</div>
            <!-- <div class="novel-des">上架时间：{{ bookInfo.create_time }}</div> -->
            <div>
                <el-button type="info" class="btn" size="mini" round @click="copyToClipboard(bookInfo.id)">复制bookid</el-button>
                <el-button type="warning" class="btn" size="mini" round @click="copyToClipboard(bookInfo.name)">复制书名</el-button>
            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    name: 'bookInfo',
    props: {
        bookInfo: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            clipboard: null
        }
    },
    mounted() {
    },
    methods: {
        toDetail(bid, cid) {
            this.$router.push({ path: '/detail', query: { bookid: bid, chapter_id: cid } });
        },
        copyToClipboard(id) {
            const textArea = document.createElement('textArea')
            textArea.value = id
            textArea.style.width = 0
            textArea.style.position = 'fixed'
            textArea.style.left = '-999px'
            textArea.style.top = '10px'
            textArea.setAttribute('readonly', 'readonly')
            document.body.appendChild(textArea)

            textArea.select()
            document.execCommand('copy')
            if (document.execCommand('copy')) {
                this.$message({
                    message: '内容已成功复制到剪切板',
                    type: 'success'
                })
            } else {
                this.$message('复制失败')
            }
            document.body.removeChild(textArea)
        }
    }
}
</script>
  
<style scoped lang="scss">
.book {
    width: 50%;
    height: 160px;
    display: flex;
    margin-bottom: 30px;

    .left-image {
        width: 120px;
        height: 160px;
        border-radius: 5px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        background: #f5f7fa;
        display: flex;
        align-items: center;
        justify-content: center;

        .imgmask {
            background: linear-gradient(180deg, transparent 34.38%, rgba(0, 0, 0, .8));
            border-radius: 0 0 4px 4px;
            bottom: 0;
            height: 30px;
            left: 0;
            position: absolute;
            width: 100%;
            z-index: 1;
            color: #fff;
            padding-left: 10px;
        }
    }

    .right-info {
        flex: 1;
        margin-left: 25px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;

        .noveltitle {
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            cursor: pointer;
        }

        .novel-des {
            color: rgba(0, 0, 0, .4);
            height: 22px;
            margin-top: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        ::v-deep .el-button.is-round {
            border-radius: 20px;
            padding: 9px 12px;
        }
    }
}
</style>
  